// eslint-disable-next-line consistent-default-export-name/default-import-match-filename
import DataCell from './DataCell'
import HeaderDataCell from './HeaderDataCell'
import Row from './server/elements/Row'
import { memo } from 'react'
import { useColumns } from './utils/TableStore'
function DataRow<T extends Record<string, unknown>>({
  rowId,
  pivot,
  index,
}: {
  rowId: string
  pivot: boolean
  index: number
}) {
  const columns = useColumns<T>()
  const firstRow = pivot && !index
  return (
    <Row>
      {columns.map((column, colIndex) => {
        const field = pivot ? rowId : column
        const dataId = pivot ? column : rowId
        if (pivot && !colIndex)
          return <HeaderDataCell key={dataId} field={field} firstRow={firstRow} colIndex={colIndex} fixed />
        return <DataCell dataId={dataId} field={field} firstRow={firstRow} key={column} colIndex={colIndex} />
      })}
    </Row>
  )
}

export default memo(DataRow)
